let DataSync = {
  get: async function (params) {
    const authToken = await localStorage.getItem("token");
    let query_string = params ? `?${new URLSearchParams(params).toString()}` : "";
    let url = `${process.env.REACT_APP_API_BASE_URL}/support/data-sync${query_string}`;
    const request = new Request(url, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: authToken,
      }),
    });
    const response = await fetch(request);
    const json = await response.json();
    return { data: json.data, total: json.pagination.total };
  },
  load: async function (client_uuid) {
    const authToken = await localStorage.getItem("token");
    const url = `${process.env.REACT_APP_API_BASE_URL}/support/data-sync/${client_uuid}`;
    const request = new Request(url, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: authToken,
      }),
    });
    const response = await fetch(request);
    const json = await response.json();
    return json;
  },
  updateStatus: async function (client_uuid, provisioning_status) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/data-sync/${client_uuid}`,
      {
        method: "PATCH",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
        body: JSON.stringify({ provisioning_status }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  resetFinalization: async function (client_uuid) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/data-sync/${client_uuid}`,
      {
        method: "PATCH",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
        body: JSON.stringify({ reset_finalization: true }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  remove: async function (client_uuid) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/data-sync/${client_uuid}`,
      {
        method: "DELETE",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  deleteFiles: async function (client_uuid) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/data-sync/${client_uuid}/s3-folder`,
      {
        method: "DELETE",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  getFailedFiles: async function (client_uuid) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/data-sync/${client_uuid}/failed-files`,
      {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  markCloudProvisioned: async function (client_uuid) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/data-sync/${client_uuid}/cloud-provisioned`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  markCustomerLive: async function (client_uuid) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/data-sync/${client_uuid}/customer-live`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
};
export default DataSync;
